import { useEffect, useRef } from 'react'
import { useProgress } from 'hooks/useProgress'
import { LoadingProgresses } from 'screens/VirtualMarketerOnboarding/Loading/LoadingProgresses'

interface Props {
  finishedLoading?: boolean
}

export const LoadingState = ({ finishedLoading }: Props) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const {
    start: startFour,
    isRunning: isRunningFour,
    progress: progressFour,
  } = useProgress({ linearProgress: true, speed: 25, immediateComplete: false })
  const {
    start: startThree,
    isRunning: isRunningThree,
    progress: progressThree,
  } = useProgress({ linearProgress: true, speed: 25, immediateComplete: true, onDone: startFour })
  const {
    start: startTwo,
    isRunning: isRunningTwo,
    progress: progressTwo,
  } = useProgress({ linearProgress: true, speed: 25, immediateComplete: true, onDone: startThree })
  const {
    start: startOne,
    isRunning: isRunningOne,
    progress: progressOne,
  } = useProgress({ linearProgress: true, speed: 25, immediateComplete: true, onDone: startTwo })

  if (!isRunningOne && progressOne === 0) {
    startOne()
  }

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
    }
  }, [])

  const progressOneText = isRunningOne ? 'Creating your workspace' : 'Create your workspace'
  const progressTwoText = isRunningTwo ? 'Preparing your content plan' : 'Prepare your content plan'
  const progressThreeText = isRunningThree ? 'Generating campaigns' : 'Generate campaigns'
  const progressFourText = isRunningFour ? 'Scheduling posts' : 'Schedule posts'

  const progresses = [
    {
      title: progressOne === 100 ? 'Created your workspace' : progressOneText,
      isRunning: isRunningOne,
      percentComplete: finishedLoading ? 100 : progressOne,
    },
    {
      title: progressTwo === 100 ? 'Prepared your content plan' : progressTwoText,
      isRunning: isRunningTwo,
      percentComplete: finishedLoading ? 100 : progressTwo,
    },
    {
      title: finishedLoading || progressThree === 100 ? 'Generated campaigns' : progressThreeText,
      isRunning: isRunningThree && !finishedLoading,
      percentComplete: finishedLoading ? 100 : progressThree,
    },
    {
      title: finishedLoading || progressFour === 100 ? 'Scheduled posts' : progressFourText,
      isRunning: isRunningFour && !finishedLoading,
      percentComplete: finishedLoading ? 100 : progressFour,
    },
  ]

  return <LoadingProgresses progresses={progresses} finishedLoading={finishedLoading} showLoadingSpinner />
}
